import React, {useState, useEffect, useRef, useContext} from "react";
import Container from "../../components/Container";
import styled from "styled-components";
import CarouselComplete from "../../components/carousel/Carousel";
import OfferProduct from "../../components/products/OfferProduct";
import Color from "../../assets/Colors";
import {ContentContainer} from "../../styles/Products";
import {Content} from "../../styles/GlobalStyles";
import scrollToRef from "../../constants/DownAction";
import {useLocation, useHistory} from "react-router-dom";
import {ConfirmUserService} from "../../services/UserServices";
import useQuery from "../../hooks/useQuery";
import {SlidesHomeService} from "../../services/GeneralServices";
import {HomeContext} from "../../context/HomeContext";
import {LoadComponet} from "../../components/loaders/Loader";

export default function Home() {
   const refItems = useRef(null);
   const {getSlides, homeSlides, getBlocks, homeBlocks} = useContext(HomeContext);
   let location = useLocation();
   let history = useHistory();
   let query = useQuery();
   const executeScroll = () => scrollToRef(refItems);

   const [list, setList] = useState([]);
   const [isLoading, setIsLoading] = useState(true);

   useEffect(() => {
      getSlides();
      getBlocks();
   }, []);

   useEffect(() => {
      getTokenUrl();
   }, [location]);

   const getTokenUrl = () => {
      if (
         history.location.search.indexOf("newsLetter") > -1 ||
         history.location.search.indexOf("privacy") > -1 ||
         history.location.search.indexOf("terms") > -1
      ) {
         // console.log("Es un modal");
      } else {
         let token = location.search.replace("?", "");
         if (token) {
            ConfirmUserService({token})
               .then((res) => res.json())
               .then((resp) => {
                  const {status} = resp;
                  if (status === "error") throw new Error();
                  history.push("/verificado", {verified: true});
               })
               .catch((e) => {
                  console.log(e);
                  history.push("/verificado", {verified: false});
               });
         }
      }
   };

   return (
      <Container>
         {homeSlides.isLoading ? <LoadComponet /> : <CarouselComplete slides={homeSlides} />}
         <ContentTitle>
            <h2 className="titleSection">
               Descubre toda la oferta educativa <br />
               de Domecq Academy
            </h2>
            <button onClick={executeScroll}>
               <img src={require("../../assets/icons/arrow_right.png")} alt="down" />
            </button>
         </ContentTitle>
         <Content ref={refItems}>
            <ContentContainer className="first" id="blocks">
               {homeBlocks.isLoading ? (
                  <LoadComponet />
               ) : (
                  homeBlocks.data.map((item, index) => <OfferProduct itemData={item} key={index} />)
               )}
            </ContentContainer>
         </Content>
      </Container>
   );
}

const ContentTitle = styled.div`
   padding: 2em 0;
   display: flex;
   justify-content: center;
   align-items: center;
   flex-direction: column;

   .titleSection {
      color: ${Color.primary};
      text-align: center;
      margin-top: 16px;
   }

   & button {
      background: transparent;
      outline: none;
      border: none;
      cursor: pointer;
   }
   & img {
      margin-top: 1em;
      transform: rotate(90deg);
      width: 25px;
      height: 25px;
   }
   @media screen and (max-width: 1600px) {
      padding: 1.5em 0;

      & .titleSection {
         font-size: 1.4em;
      }

      & img {
         margin-top: 0;
      }

      & .titleSection {
         margin-bottom: 0.9em;
      }
   }

   @media screen and (max-width: 800px) {
      padding: 1em 0;

      & .titleSection {
         font-size: 1.1em;
      }

      & img {
         width: 15px;
         height: 15px;
      }

      & .titleSection {
         margin-bottom: 0.9em;
      }
   }

   @media screen and (max-width: 500px) {
      & .titleSection {
         font-size: 0.9em;
      }

      & img {
         margin-top: 1.5em;
         width: 15px;
         height: 15px;
      }
   }
`;
